module.exports = __webpack_public_path__ + "img/fan.41cce253.svg";